const bugReportPageTranslations = {
  breadCrumbs: {
    heading: "الابلاغ عن اخطاء",
    links: {
      1: "الرئيسية",
      2: "الابلاغ عن اخطاء",
    },
  },
  title: "الابلاغ عن اخطاء",
  description: `نسعى جاهدين لجعل تطبيقنا خالياً من العيوب قدر الإمكان، ولكن
    أحياناً تتسلل بعض الأخطاء. إذا واجهتك مشكلة ما، نحن هنا لمساعدتك! الرجاء استخدام النموذج أدناه ل
    الإبلاغ عن أي أخطاء أو مشكلات قد واجهتها. ملاحظاتك ثمينة في مساعدتنا على التحسين.`,
  cta: "بحاجة إلى مساعدة أكثر؟",
};

export default bugReportPageTranslations;
